var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('m-img',{attrs:{"src":require("@/v2/mobile/assets/image/h_60.jpg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }